"use client";

import type { EventNameType } from "@homeinstead/shared";
import type { EventPayload } from "./types";

import { getAnalytics } from "./analytics-init";

export function page(properties?: Record<string, unknown>): void {
  const analytics = getAnalytics({ logEvent: "page" });
  if (!analytics) {
    return;
  }

  analytics.page(properties);
}

/**
 * Identify a user with traits using their Segment anonymous ID
 *
 * In most cases, we don't have another ID to use so we use the anonymous ID
 * @param traits
 */
export async function identifyAnonymous(
  traits?: Record<string, unknown>,
): Promise<void> {
  const analytics = getAnalytics({ logEvent: "identify" });
  if (!analytics) {
    return;
  }

  // we're grabbing the anonymous ID from here
  // in future, if we need to set our own ID,
  // make a separate identify function
  const user = await analytics.user();
  const anonymousId = user.anonymousId();

  await analytics.identify(anonymousId, traits);
}

function trackWithTransport(
  eventName: EventNameType,
  properties: EventPayload | undefined,
  transport?: "sendBeacon",
): void {
  const analytics = getAnalytics({ logEvent: "track" });
  if (!analytics) {
    return;
  }

  analytics.track(eventName, properties, transport ? { transport } : undefined);
}

export function track(
  eventName: EventNameType,
  properties?: EventPayload,
): void {
  trackWithTransport(eventName, properties);
}

export function trackBeacon(
  eventName: EventNameType,
  properties?: EventPayload,
): void {
  trackWithTransport(eventName, properties, "sendBeacon");
}

export { getAnalytics };
